import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "@/App";
import Hero from "@/sections/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import LocaleSection from "@/sections/LocaleSection";
import SaporiSection from "@/sections/SaporiSection";
import SignatureSection from "@/sections/SignatureSection";
import FormuleSection from "@/sections/FormuleSection";
import ServiziSection from "@/sections/ServiziSection";
import GallerySection from "@/sections/GallerySection";
import ReviewsSection from "@/sections/ReviewsSection";
import ContattiSection from "@/sections/ContattiSection";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target && target !== "top") {
      const timer = setTimeout(() => scrollToHash(target), 350);
      return () => clearTimeout(timer);
    }
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [location.state]);

  return (
    <main>
      <Hero />
      <EditorialMarquee />
      <LocaleSection />
      <SaporiSection />
      <SignatureSection />
      <FormuleSection />
      <ServiziSection />
      <GallerySection />
      <ReviewsSection />
      <ContattiSection />
    </main>
  );
};

export default HomePage;
